(() => {
  const tabletPayments = matchMedia('(min-width: 768px) and (max-width: 1023px), (min-width: 1024px) and (max-width: 1366px) and (any-pointer: coarse)');
  const initPayments = (root = document) => {
    root.querySelectorAll('.vault-footer__bottom').forEach((bottom) => {
      if (bottom.dataset.balancedPayments) return;
      const icons = bottom.querySelector('.coin-payment-icons');
      const payments = bottom.querySelector('.vault-footer__payments');
      if (!icons || !payments) return;
      bottom.dataset.balancedPayments = 'true';
      const update = () => {
        if (!bottom.isConnected) {
          observer.disconnect();
          tabletPayments.removeEventListener('change', update);
          return;
        }
        icons.style.removeProperty('width');
        if (!tabletPayments.matches) return;
        const count = icons.querySelectorAll(':scope > .coin-payment-icon').length;
        if (!count) return;
        const style = getComputedStyle(icons);
        const size = parseFloat(style.getPropertyValue('--footer-payment-width'));
        const gap = parseFloat(style.columnGap) || 0;
        const bottomStyle = getComputedStyle(bottom);
        const siblings = [...bottom.children].filter((child) => child !== payments);
        const available = bottom.clientWidth - (parseFloat(bottomStyle.paddingLeft) || 0) - (parseFloat(bottomStyle.paddingRight) || 0)
          - siblings.reduce((width, child) => width + child.getBoundingClientRect().width, 0)
          - (parseFloat(bottomStyle.columnGap) || 0) * siblings.length;
        const columns = count * size + (count - 1) * gap > available + 1 ? Math.ceil(count / 2) : count;
        icons.style.width = `${columns * size + (columns - 1) * gap}px`;
      };
      const observer = new ResizeObserver(update);
      observer.observe(bottom);
      [...bottom.children].filter((child) => child !== payments).forEach((child) => observer.observe(child));
      tabletPayments.addEventListener('change', update);
      update();
    });
  };
  initPayments();
  document.addEventListener('shopify:section:load', (event) => initPayments(event.target));
  if (customElements.get('vault-footer-accordion')) return;
  customElements.define('vault-footer-accordion', class extends HTMLElement {
    connectedCallback() {
      this.mobile = matchMedia('(max-width: 767px)');
      this.onBreakpoint = () => this.querySelectorAll('.vault-footer__toggle').forEach((button) => this.updatePanel(button));
      this.mobile.addEventListener('change', this.onBreakpoint);
      this.onClick = (event) => {
        const button = event.target.closest('.vault-footer__toggle');
        if (!button || !this.contains(button) || !this.mobile.matches) return;
        button.setAttribute('aria-expanded', String(button.getAttribute('aria-expanded') !== 'true'));
        this.updatePanel(button);
      };
      this.querySelectorAll('.vault-footer__toggle').forEach((button) => this.updatePanel(button));
      this.addEventListener('click', this.onClick);
      this.classList.add('is-enhanced');
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mobile.removeEventListener('change', this.onBreakpoint);
    }

    updatePanel(button) {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel || !this.contains(panel)) return;
      const collapsed = button.getAttribute('aria-expanded') !== 'true';
      panel.classList.toggle('is-collapsed', collapsed);
      panel.inert = this.mobile.matches && collapsed;
    }
  });
})();
